import { Box, Spinner, Text, VStack } from '@chakra-ui/react';

const LoadingComponent = ({ message = 'Loading...' }: { message?: string }) => {
  return (
    <Box
      // position="fixed"
      // top={0}
      // left={0}
      // width="100vw"
      // height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="rgb(255, 255, 255)"
      // zIndex={9999}
    >
      <VStack spacing={3}>
        <Spinner
          alignSelf={'center'}
          size="lg"
          mt={8}
          mx="auto"
          display="block"
          color="#009800ff"
        />
        <Text fontSize="md" color="gray.700" fontWeight="medium">
          {message}
        </Text>
      </VStack>
    </Box>
  );
};

export default LoadingComponent;
